import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import Popup from "./Popup";
import "./SkinConcerns.css";

const SkinConcerns = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cameFromProfile = location.state?.fromProfile === true;
  const [selectedItems, setSelectedItems] = useState([]);
  const [skinConcernsList, setSkinConcernsList] = useState([]);
  const [currentStep] = useState(2);
  const [showSkipPopup, setShowSkipPopup] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    const stored = JSON.parse(sessionStorage.getItem("skin-concerns")) || [];
    setSelectedItems(stored);

    const getSkinConcerns = async () => {
      try {
        const res = await fetch("https://dev-api.curu.com.au/api/skin-concerns", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          console.error("GET /api/skin-concerns failed:", res.status);
          return;
        }
        const data = await res.json();
        setSkinConcernsList(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Error fetching skin concerns list:", e);
      }
    };

    getSkinConcerns();
  }, []);

  useEffect(() => {
    sessionStorage.setItem("skin-concerns", JSON.stringify(selectedItems));
  }, [selectedItems]);

  const toggleSelection = (item) => {
    setSelectedItems((prev) => {
      const exists = prev.some((i) => i.id === item.id);
      const next = exists ? prev.filter((i) => i.id !== item.id) : [...prev, item];
      sessionStorage.setItem("skin-concerns", JSON.stringify(next));
      return next;
    });
  };

  const handleNextClick = () => {
    sessionStorage.setItem("skin-concerns", JSON.stringify(selectedItems));
    navigate("/skin-sensitivity");
  };

  const handleSkipClick = () => setShowSkipPopup(true);
  const handleSkipConfirm = () => {
    setShowSkipPopup(false);
    sessionStorage.setItem("skin-concerns", JSON.stringify([]));
    setSelectedItems([]);
    navigate("/skin-sensitivity");
  };

  const handleUpdateConcernsClick = async () => {
    const skinConcernIds = selectedItems.map((c) => c.id);
    const quizData = { skin_concerns: skinConcernIds };

    console.log("Skin quiz data to store in database:", quizData);

    try {
      const response = await fetch("https://dev-api.curu.com.au/api/profile", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(quizData),
      });

      if (!response.ok) {
        let detail = {};
        try { detail = await response.json(); } catch (_) {}
        console.error("PATCH /api/profile failed:", response.status, detail);
        throw new Error("Failed to save the skin quiz data.");
      }

      navigate("/user-profile");
    } catch (error) {
      console.error("Error saving quiz data:", error?.message || error);
      alert("There was a problem saving your quiz data. Please try again.");
    }
  };

  const isSelected = (item) => selectedItems.some((s) => s.id === item.id);

  return (
    <div className="page-container-skin-concerns">
      <div className="skin-concerns-container">
        <button
          type="button"
          className="skip-link-skin-concerns"
          onClick={() => {
            if (cameFromProfile) {
              navigate("/user-profile");
            } else {
              navigate(-1);
            }
          }}
          style={{ top: 8, right: 10 }}
        >
          Close
        </button>

        {!cameFromProfile && (
          <div style={{ marginBottom: 10 }}>
            <ProgressBar currentStep={currentStep} totalSteps={5} />
          </div>
        )}

        {!cameFromProfile && (
          <button
            type="button"
            className="skip-link-skin-concerns"
            onClick={handleSkipClick}
            style={{ top: 48, right: 10 }}
          >
            Skip
          </button>
        )}

        <div className="content-box">
          <div className="title-container-skin-concerns">
            <h1 className="title-skin-concerns">Skin Concerns</h1>
          </div>

          <div className="selection-boxes">
            {skinConcernsList.length === 0 ? (
              <div className="selection-item" style={{ opacity: 0.6, cursor: "default" }}>
                Loading concerns...
              </div>
            ) : (
              skinConcernsList.map((item) => (
                <div
                  key={item.id}
                  className={`selection-item ${isSelected(item) ? "selected" : ""}`}
                  onClick={() => toggleSelection(item)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") toggleSelection(item);
                  }}
                >
                  {item.name}
                </div>
              ))
            )}
          </div>

          <div className="concernsbuttons-container" style={{ marginTop: 24 }}>
            {!cameFromProfile ? (
              <>
                <button
                  type="button"
                  className="back-button-skin-concerns"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
                <button
                  type="button"
                  className={`next-button-skin-concerns ${
                    selectedItems.length === 0 ? "disabled" : ""
                  }`}
                  onClick={handleNextClick}
                  disabled={selectedItems.length === 0}
                >
                  Next
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="back-button-skin-concerns"
                  onClick={() => navigate(-1)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="next-button-skin-concerns"
                  onClick={handleUpdateConcernsClick}
                >
                  Save
                </button>
              </>
            )}
          </div>
        </div>

        {showSkipPopup && (
          <Popup
            isVisible={showSkipPopup}
            title="Skip Skin concerns"
            onClose={() => setShowSkipPopup(false)}
            onConfirm={handleSkipConfirm}
          />
        )}
      </div>
    </div>
  );
};

export default SkinConcerns;
